module.exports = __webpack_public_path__ + "static/media/37_B.705ee676.png";